/**
 * WHICH SERVER AM I ON? (Jamie, 19/10/26: "make it easy to know I'm in sandbox, not real"). The sandbox and live run
 * the very same build, so nothing changes at publish: the page asks its own server (/version) and only a sandbox (or a
 * developer's copy) marks itself. Live shows nothing.
 *  - The browser tab: "SANDBOX · " before the title, and an amber icon with an S.
 *  - On the page: an amber stripe across the very top with a small "SANDBOX · not real" tag (it never takes taps).
 */
const LABEL = { sandbox: "SANDBOX", development: "DEV" };
export async function markEnvironment() {
    let env = "";
    try {
        env = String((await (await fetch("/version", { cache: "no-store" })).json()).env ?? "");
    }
    catch {
        return;
    }
    const label = LABEL[env];
    if (!label || window.location.pathname.startsWith("/tv"))
        return; // live: nothing; TV screens stay clean
    document.documentElement.dataset.env = env;
    // The tab's title, kept marked whatever a page sets it to.
    const prefix = `${label} · `;
    const fix = () => { if (!document.title.startsWith(prefix))
        document.title = prefix + document.title.replace(/^(SANDBOX|DEV) · /, ""); };
    fix();
    new MutationObserver(fix).observe(document.head, { subtree: true, childList: true, characterData: true });
    // The tab's icon: amber, with the first letter.
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><rect width="64" height="64" rx="14" fill="#f59e0b"/><text x="32" y="45" font-family="Arial,Helvetica,sans-serif" font-size="40" font-weight="900" text-anchor="middle" fill="#111">${label[0]}</text></svg>`;
    const href = `data:image/svg+xml,${encodeURIComponent(svg)}`;
    document.querySelectorAll("link[rel~='icon']").forEach((l) => l.remove());
    const link = Object.assign(document.createElement("link"), { rel: "icon", type: "image/svg+xml", href });
    document.head.appendChild(link);
    // The stripe and its tag.
    const bar = document.createElement("div");
    bar.className = "tc-envbar";
    bar.setAttribute("role", "note");
    bar.innerHTML = `<span>${label} · not real</span>`;
    document.body.appendChild(bar);
}
